var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarreDArrimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_15",
    "data-name": "Calque 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1614.3 1003.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#f7f7f5;stroke:#000;stroke-miterlimit:10;stroke-width:3px;}.cls-4{fill:#030301;}.cls-5{fill:#454545;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-195.41 -534.24)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1808,567.06,1765,536,1245.38,810.74c-1-23.35-6.43-33.4-17.91-25.09l-63.31,28.67c-2,9.77-1.21,16.82,10.75,13.14,0,0,13.14-8.36,31.06-17.92s16.72,16.73,16.72,16.73L421.17,1259.88l7.17,8.36L220.49,1385.3l52.56,84.81,211.43-121.84L587.21,1494l66.89-43-6-37L566.9,1298.1l451.53-254.43,10.75-1.2c5,46.2,54.94,60.92,83.61,40.62s25.34-58.44-15.53-80l179.18-100.33L1300.33,929c-14.42-6.62-15.88,35.37,2.39,44.19,19.07,9.21,29.86,0,28.67-10.75l53.75,51.37,53.76-34.65L1461.59,929l-86-84.82,421.66-235.31Zm-701.18,479c0,9.89-10.7,17.92-23.89,17.92s-23.89-8-23.89-17.92,10.7-17.92,23.89-17.92S1106.82,1036.16,1106.82,1046.06Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "barre d&amp;apos;arrimage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1808,567.06,1765,536,1245.38,810.74c-1-23.35-6.43-33.4-17.91-25.09l-63.31,28.67c-2,9.77-1.21,16.82,10.75,13.14,0,0,13.14-8.36,31.06-17.92s16.72,16.73,16.72,16.73L421.17,1259.88l7.17,8.36L220.49,1385.3l52.56,84.81,211.43-121.84L587.21,1494l66.89-43-6-37L566.9,1298.1l451.53-254.43,10.75-1.2c5,46.2,54.94,60.92,83.61,40.62s25.34-58.44-15.53-80l179.18-100.33L1300.33,929c-14.42-6.62-15.88,35.37,2.39,44.19,19.07,9.21,29.86,0,28.67-10.75l53.75,51.37,53.76-34.65L1461.59,929l-86-84.82,421.66-235.31Zm-701.18,479c0,9.89-10.7,17.92-23.89,17.92s-23.89-8-23.89-17.92,10.7-17.92,23.89-17.92S1106.82,1036.16,1106.82,1046.06Z",
    transform: "translate(-195.41 -534.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.49,1372.16l43,66.89L480.9,1316l96.75,141,70.48-43s21.5,3.58,25.08,4.78S684,1477.28,684,1477.28L545.4,1538.2l-310.57-68.09-39.42-84.81Z",
    transform: "translate(-195.41 -534.24)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "83.62 938.26 68.09 904.81 285.49 781.78 292 821.24 83.62 938.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M566.9,1298.1l-16.72-23.89,481.39-268.77,4.77,7.17s-8.36,10.75-7.16,29.86S586,1305.27,586,1305.27Z",
    transform: "translate(-195.41 -534.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1097.26,1003.05a28.9,28.9,0,0,0-19.11,0c-7.16-6-8.36-9.55-13.14-8.36-2.39,0-4.78-3.58-4.78-3.58l219.79-123L1394.7,973.19l49-31.06-4.77,51.37-76.45,44.2Z",
    transform: "translate(-195.41 -534.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1379.17,1037.7c1.19-1.2,15.53-64.51,15.53-64.51l49-31.06-6,72.87Z",
    transform: "translate(-195.41 -534.24)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1165.85 295.61 1180.18 309.95 1601.84 74.63 1612.59 32.82 1141.95 300.39 1147.93 305.17 1165.85 295.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1222.69,826.27l25.85-17.2-12.71-49.7s-113.48,59.73-113.48,60.92,26.28,34.65,26.28,34.65Z",
    transform: "translate(-195.41 -534.24)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1307.83,
    cy: 952.65,
    rx: 14.93,
    ry: 23.71,
    transform: "translate(-472.99 741.55) rotate(-47.59)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1303.05,
    cy: 959.82,
    rx: 14.93,
    ry: 23.71,
    transform: "translate(-479.84 740.36) rotate(-47.59)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1147.93 305.17 1249.46 401.92 1244.68 405.51 1138.37 303.97 1141.95 300.39 1147.93 305.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "835.56 470.61 868.87 454.61 870.2 457.47 835.56 475.39 835.56 470.61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarreDArrimage);
export default __webpack_public_path__ + "static/media/barre_d_arrimage.aae856ebc9f11be0e2eef70a8cf6dfdb.svg";
export { ForwardRef as ReactComponent };